import Phaser from 'phaser';

interface IAsset {
  key: string;
  data: any;
}

interface IMultiAtlas {
  atlasURL: string;
  path: string;
}

class AssetLoader {
  private static instance: AssetLoader;
  private textures: IAsset[] = [];
  private multiAtlas: IAsset[] = [];
  private sounds: IAsset[] = [];

  private assetCounter = 0;
  private loading = false;

  private constructor() {}

  public static getInstance(): AssetLoader {
    if (!AssetLoader.instance) {
      AssetLoader.instance = new AssetLoader();
    }

    return AssetLoader.instance;
  }

  public addTexture(key: string, data: any) {
    this.textures.push({ key, data });
  }

  public addSprite(key: string, data: IMultiAtlas) {
    this.multiAtlas.push({ key, data });
  }

  public addSound(key: string, data: any) {
    this.sounds.push({ key, data });
  }

  public load(scene: Phaser.Scene, onLoadStart: () => void, onLoadComplete: () => void) {
    if (!this.loading) {
      onLoadStart();
      this.loading = true;
    }

    this.textures.forEach(({ key, data }) => {
      scene.textures.addBase64(key, data).once('onload', () => {
        this.loadComplete(onLoadComplete);
      });
    });

    this.sounds.forEach(({ key, data }) => {
      scene.load.audio(key, data).once('complete', () => {
        this.loadComplete(onLoadComplete);
      });
    });

    this.multiAtlas.forEach(({ key, data }) => {
      scene.load.multiatlas(key, data.atlasURL, data.path).once('complete', () => {
        this.loadComplete(onLoadComplete);
      });
    });
  }

  private loadComplete(onLoadComplete: () => void) {
    this.assetCounter += 1;
    const totalCount = this.multiAtlas.length + this.textures.length + this.sounds.length;

    if (this.assetCounter >= totalCount) {
      setTimeout(() => onLoadComplete(), 1000);
      this.loading = false;
    }
  }
}

export const addTextureBase64 = (key: string, data: any) => {
  AssetLoader.getInstance().addTexture(key, data);
};

export const addAudio = (key: string, data: any) => {
  AssetLoader.getInstance().addSound(key, data);
};

export const addMultiAtlas = (key: string, data: IMultiAtlas) => {
  AssetLoader.getInstance().addSprite(key, data);
};

export const loadAssets = (scene: Phaser.Scene, onLoadStart: () => void, onLoadComplete: () => void) => {
  AssetLoader.getInstance().load(scene, onLoadStart, onLoadComplete);
};
